import React from "react";

const Sponsor = () => {
  return (
    <section id="sponsors" className="py-16 bg-gray-100">
      <div className="max-w-6xl mx-auto px-6 text-center">
        {/* Heading */}
        <h2 className="text-4xl font-bold text-purple-600 mb-6">
          Our Sponsors
        </h2>
        <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
          Thank you for being a valued partner in our mission.
          Your generous sponsorship plays a vital role in empowering our students,
          supporting innovation, and strengthening the vision of our college.
          Together, we are building a brighter future.
        </p>

      {/* Sponsors Logos Grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-12 place-items-center">
  {/* Sponsor 1 */}
  <a
    href="https://www.ucil.gov.in/tummalapalleproject.html"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/images/sponsors/logo1.png"
      alt="Sponsor 1"
      className="max-h-30 object-contain transition-transform duration-300 hover:scale-110"
    />
  </a>

  {/* Sponsor 2 */}
  <a
    href="https://arthabotstechnologies.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/images/sponsors/logo2.png"
      alt="Sponsor 2"
      className="max-h-24 object-contain transition-transform duration-300 hover:scale-110"
    />
  </a>

  {/* Sponsor 3 */}
  <a
    href="https://vizagport.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/images/sponsors/logo3.png"
      alt="Sponsor 3"
      className="max-h-26 object-contain transition-transform duration-300 hover:scale-110"
    />
  </a>
</div>




        {/* Sponsor Profile Section */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 bg-white shadow-lg p-6 rounded-2xl">
          {/* Image */}
  <img
  src="/images/sponsors/sumathi.png"
  alt="Smt. Karna Sathi Sumathi"
  className="w-44 h-44 rounded-full object-contain bg-white p-2 shadow-md"
/>




          {/* Text */}
          <div className="text-left">
            <h3 className="text-2xl font-semibold text-purple-700">
              Smt. Karna Sathi Sumathi
            </h3>
            <p className="text-gray-700">Email: <a href="mailto:sumathiatk@gmail.com" className="text-blue-600">sumathiatk@gmail.com</a></p>
            <p className="text-gray-700">Team Leader</p>

            <p className="text-gray-700 font-medium">
              Accenture IT Solutions, Bangalore
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsor;
